"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = void 0;

var _util = require("../../../util");

const wrapper = ({
  theme
}) => ({ ...(0, _util.textStyle)(theme, 'body'),
  color: (0, _util.color)(theme, 'text.2'),
  height: 64,
  overflow: 'hidden',
  position: 'relative',
  ':after': {
    background: (0, _util.color)(theme, 'background.black'),
    borderTopLeftRadius: '50%',
    borderTopRightRadius: '50%',
    bottom: 0,
    content: '""',
    height: 8,
    left: '50%',
    position: 'absolute',
    transform: 'translate(-50%, 100%)',
    transition: 'transform 0.3s ease',
    width: 8
  },
  '&.active': {
    color: (0, _util.color)(theme, 'text.1'),
    ':after': {
      transform: 'translate(-50%, 50%)'
    }
  }
});

exports.wrapper = wrapper;
//# sourceMappingURL=NavTab.style.js.map